import { DMsList } from './DMsList';
import { SpacesList } from './SpacesList';
import { useSelectedDM } from './SelectedDMContext';
import { useSelectedSpace } from './SelectedSpaceContext';

interface SidebarProps {
  collapsed?: boolean;
}

export function Sidebar({ collapsed = false }: SidebarProps) {
  const { selectedDmId, setSelectedDmId } = useSelectedDM();
  const { setSelectedSpaceId } = useSelectedSpace();
  return (
    <nav
      className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}
      aria-label="Sidebar navigation"
      aria-hidden={collapsed}
    >
      <section
        className="sidebar-section"
        aria-labelledby="sidebar-spaces-heading"
      >
        <div className="sidebar-header">
          <h2 id="sidebar-spaces-heading">Spaces</h2>
        </div>
        <SpacesList onSelectSpace={() => setSelectedDmId(null)} />
      </section>
      <section
        className="sidebar-section sidebar-section-dms"
        aria-labelledby="sidebar-dms-heading"
      >
        <div className="sidebar-header">
          <h2 id="sidebar-dms-heading">Direct messages</h2>
          <span className="sidebar-header-badge" aria-label="Coming soon">
            preview
          </span>
        </div>
        <DMsList
          selectedDmId={selectedDmId}
          onSelectDM={(dmId) => {
            setSelectedDmId(dmId);
            setSelectedSpaceId(null);
          }}
        />
      </section>
    </nav>
  );
}
